import React from 'react';

const AboutKhosikhadi = () => {
  return (
    <section id="who" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-light text-center tracking-wide mb-4">WHO IS KHOSIKHADI MMATLALA WA MUDAU?</h2>
        <div className="section-divider"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
          <div className="flex flex-col justify-center" data-aos="fade-right">
            <p className="italic mb-6 leading-relaxed">
              <em>Ndi Mudau wa Tshakuma dombwe Madzivhandila Ndi Muduhulu wa Mangedzani</em>
            </p>
            
            <p className="text-gray-700 mb-6 leading-relaxed">
              Khosikhadi Mmatala wa Mudau is the Founder/ Mother of Botswalle- the Sisterhood Youth Foundation, 
              storyteller, actress, poet writer and model. An individual driven by humanitarian work, devising art 
              as a component to express self artistry and connect to the world. Khosikhadi is a spirited individual, 
              she leads with passion and purpose, as she believes these are recipe to living a fulfilling life.
            </p>
            
            <p className="text-gray-700 mb-6 leading-relaxed">
              Khosikhadi has graduated from the University of Kwa-Zulu Natal (2021) in Drama studies and Industrial 
              psychology. in this time her love for working with people on dynamics of healing, mental health and 
              self artistry (creation) became her passion. Although for her she believes it all start with "Self" 
              then to the world around "You".
            </p>
            
            <p className="text-gray-700 leading-relaxed">
              This later developed in the long journey of self alchemy and sharing that journey while accommodating 
              the lessons that come with it, to the community around her. That aligned Khosikhadi's passion to share 
              her story through her Foundation Botswalle, as well as her storytelling journey it be through acting, 
              performing arts, writing and her pictorial storytelling carried by her modeling journey.
            </p>
          </div>
          <div data-aos="fade-left">
            <img 
              src="/images/image00007.jpeg" 
              alt="Khosikhadi Mmatlala wa Mudau" 
              className="w-full object-cover h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutKhosikhadi;